import React from "react";
import NotAccess from "../../components/common/userNotAccess/index";
import { IsShowCreateOrder, IsShowShipmentAnalytics } from "../../utils";

function RestrictShipmentAnalytics(props) {
  if (IsShowShipmentAnalytics) return props.children;
  return <NotAccess />;
}

export default RestrictShipmentAnalytics;
